import AppWrapper from "../../components/cm/AppWrapper";
import AccountabilityLog from "../../components/cm/Dashboard/FullPages/AccountabilityLog";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <AccountabilityLog />
    </AppWrapper.WithSidebar>
  );
};
